module.exports = __webpack_public_path__ + "img/67.1e044128.jpg";